import { configureStore } from '@reduxjs/toolkit';
import OrganizationListReducer from './slices/OrganizationSlice'
import UserReducer from './slices/UserSlice'
import NotesReducer from './slices/NotesSlice'
import GlobalSearchReducer from './slices/GlobalSearchSlice'
import NotificationsReducer from './slices/NotificationsSlice'
import OrganizationsV3Reducer from './slices/OrganizationsV3Slice'

export const store = configureStore({
  reducer: {
    OrganizationListStore: OrganizationListReducer,
    UserStore: UserReducer,
    NotesStore: NotesReducer,
    GlobalSearchStore: GlobalSearchReducer,
    NotificationsStore: NotificationsReducer,
    OrganizationsV3Store: OrganizationsV3Reducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
